import * as React from "react";
import { gql, useQuery } from "@apollo/client";

import {
  // BankPreference,
  MyBankPreferencesQueryQuery
} from "../../schemaTypes";


export const myBankPreferencesQuery = gql`
  query MyBankPreferencesQuery {
    myBankPreferences {
      id
      bank {
        id
        bank
        bankCode
        pictureUrl
      }
      accountNo
      createdAt
      updatedAt
    }
  }
`;

export const newBankPreferenceSubscription = gql`
  subscription NewBankPreferenceSubscription {
    newBankPreference {
      id
      bank {
        id
        bank
        bankCode
        pictureUrl
      }
      accountNo
      createdAt
      updatedAt
    }
  }
`;


export function useBankPreferences() {
  const { data, loading, subscribeToMore } = useQuery<MyBankPreferencesQueryQuery>(myBankPreferencesQuery);

  React.useEffect(() => {
    if (!subscribeToMore) return;
    const unsubscribe = subscribeToMore({
      document: newBankPreferenceSubscription,
      updateQuery: (prev, { subscriptionData }) => {
        if (!subscriptionData.data) return prev;
        return {
          ...prev,
          myBankPreferences: [
            ...prev.myBankPreferences,
            (subscriptionData.data as any).newBankPreference
          ]
        };
      }
    });
    return () => unsubscribe();
  }, [subscribeToMore]);

  return {
    myBankPreferences: data?.myBankPreferences ?? [],
    loading
  };
}